export default {
  headerMobileActive: 8000,
  shopLayoutCategoriesToggle: 7001,
  shopLayoutCategories: 7000,
  modal: 6000,
  cartButton: 5000,
  cookiesConsent: 4000,
}
